export function createSchedulerClient(transport) {
    return {
        /**
         * POST /internal/v1/tenants/{tenantId}/schedules
         *
         * Requires scope: schedules:write
         */
        createSchedule(tenantId, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/schedules`,
                body,
                options,
            });
        },
        /**
         * GET /internal/v1/tenants/{tenantId}/schedules/{scheduleId}
         *
         * Requires scope: schedules:read
         */
        getSchedule(tenantId, scheduleId, options) {
            return transport.request({
                method: "GET",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/schedules/${encodeURIComponent(scheduleId)}`,
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/schedules/{scheduleId}/transitions
         *
         * Requires scope: schedules:write
         */
        transitionSchedule(tenantId, scheduleId, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/schedules/${encodeURIComponent(scheduleId)}/transitions`,
                body,
                options,
            });
        },
        /**
         * List every tenant's schedules, as a trigger, a recurrence and a state
         *
         * Requires scope: schedules:platform:read
         */
        listPlatformSchedules(limit, after, options) {
            return transport.request({
                method: "GET",
                path: "/v1/platform/schedules",
                query: { limit: limit, after: after },
                options,
            });
        },
        /**
         * List this tenant's schedules, as a trigger, a recurrence and a state
         *
         * Requires scope: schedules:read
         */
        listTenantSchedules(tenantId, limit, after, options) {
            return transport.request({
                method: "GET",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/schedules`,
                query: { limit: limit, after: after },
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=scheduler.js.map